import { List, fromJS } from 'immutable';
import { RestAPI } from '@/util/net.js';
import { putError } from '@/store/error.store';
import { markStoreLoading, markStoreLoaded } from '@/store/storeForStoringStatusOfStores.store';

const requestFailure = (dispatch, type, data, reportType) => {
  putError(dispatch, data);
  dispatch({ type });
  markStoreLoaded(dispatch, reportType);
  return true;
};

const requestSuccess = (dispatch, type, data, reportType) => {
  dispatch({ type, data });
  markStoreLoaded(dispatch, reportType);
  return true;
};

export const userPerformanceReportReducer = (state = new List(), action) => {
  switch (action.type) {
    case 'USER_PERFORMANCE_REPORT_LOADED':
      return fromJS(action.data);
    case 'USER_PERFORMANCE_REPORT_CLEAR':
      return new List();
    case 'CLEAR_PERFORMANCE_REPORT_DATA':
      return state.delete('from').delete('to');
    default:
      return state;
  }
};

export const generateReport = (dispatch, from, to) => {
  dispatch({ type: 'LOADING_USER_PERFORMANCE_REPORT' });
  markStoreLoading(dispatch, 'user_performance');
  return RestAPI.get(`/api/report/userPerformance?dateFrom=${from ? from.toJSON()
    .split('T')[0] : ''}&dateTo=${to ? to.toJSON().split('T')[0] : ''}`)
    .then(
      (data) => requestSuccess(dispatch, 'USER_PERFORMANCE_REPORT_LOADED', data, 'user_performance')
    ).catch(
      (data) => requestFailure(dispatch, 'USER_PERFORMANCE_REPORT_LOADED', data, 'user_performance')
    );
};

export const clearReport = (dispatch) => dispatch({ type: 'USER_PERFORMANCE_REPORT_CLEAR' });
export const clearData = (dispatch) => dispatch({ type: 'CLEAR_PERFORMANCE_REPORT_DATA' });
